import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { OffresComponent } from './offres.component';
import { OffreComponent } from './offre.component';

const routes: Routes = [
  {
    path: '',
    component: OffresComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component:OffreComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OffresRoutingModule { }

export const routedComponents = [
  OffresComponent,
  OffreComponent
];
